import { render, staticRenderFns } from "./kudos.vue?vue&type=template&id=df0e86ee&"
import script from "./kudos.vue?vue&type=script&lang=js&"
export * from "./kudos.vue?vue&type=script&lang=js&"
import style0 from "./kudos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports